import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { Formik } from "formik";
import { toastr } from "react-redux-toastr";

import { getRecordFormData } from "../../../store/modules/library/selectors";

import { FormActionTypes, validationSchema, ValueTypes } from "./formSettings";
import { RecordForm } from "./RecordForm";

import { useSetActive, ActiveType } from "../../hooks/useSetActive";
import { updateRecord } from "../../../utils/updateRecord";

export const Record: React.FC = () => {
  const { mode, initialValues, recordMetaData } = useSelector(getRecordFormData);
  useSetActive(ActiveType.record);

  const handleSubmit = useCallback((values: ValueTypes, actions: FormActionTypes) => {
    const { recordId, folderId, text, title } = values;
    const { setSubmitting } = actions;

    const patch = {
      text,
      title,
      wordCount: text.trim().split(/\s+/).length,
    };

    updateRecord([folderId, recordId], patch)
      .catch((error: Error) => {
        toastr.error("Record Update", error.message);
      })
      .finally(() => {
        setSubmitting(false);
      });
  }, []);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      render={props => <RecordForm {...props} mode={mode} recordMetaData={recordMetaData} />}
      enableReinitialize
    />
  );
};
